import { Breadcrumb, Button } from "antd";
import SearchInput from "../components/Forms/SearchInput";
import DataTable from "../components/Tables/Datatable";
import { postApi } from "../services/api";
import { useCallback, useEffect, useRef, useState } from "react";
import {
  Link,
  useNavigate,
  useOutletContext,
  useSearchParams,
} from "react-router-dom";
import { useSelector } from "react-redux";
import { items } from "../constant";
import Loader from "../common/Loader";
import PrimaryButton from "../components/Forms/PrimaryButton";
import { handleRouteNav } from "../utils";
import usePagination from "../hooks/usePagination";

const PendingClients = () => {
  const [data, setData] = useState([]);
  const [totalClients, setTotalClients] = useState(0);
  const {
    pagination,
    handleChange: handlePaginationChange,
    resetPage,
  } = usePagination();
  const navigate = useNavigate();
  const { is_admin, role_id } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const query = searchParams.get("q") || "";
  const { listRefreshKey } = useSelector((state) => state.cartRefresh);
  const fetchIdRef = useRef(0);

  const handleChange = (paginationInfo, filters, sorter) => {
    handlePaginationChange(paginationInfo, filters, sorter);
  };

  const handleClient = () => {
    navigate(handleRouteNav(is_admin ? "/customers" : "/clients", role_id));
  };

  const fetchClients = useCallback(async () => {
    fetchIdRef.current += 1;
    const currentFetchId = fetchIdRef.current;
    try {
      setLoading(true);
      const paginate = {
        page: pagination.current,
        per_page: pagination.pageSize,
        search: query,
      };
      const res = await postApi("sales/customers/pending", paginate);
      if (currentFetchId !== fetchIdRef.current) {
        return;
      }
      setData(res.data || []);
      setTotalClients(res.total || 0);
    } catch (error) {
      if (currentFetchId !== fetchIdRef.current) {
        return;
      }
      console.error("Error fetching clients:", error);
    } finally {
      if (currentFetchId !== fetchIdRef.current) {
        return;
      }
      setLoading(false);
    }
  }, [pagination.current, pagination.pageSize, query]);

  const onSearch = (value, _e, info) =>
    console.log(info === null || info === void 0 ? void 0 : info.source, value);

  const handleOnSearchChange = (e) => {
    const value = e.target.value;
    setSearchParams(
      (prev) => {
        if (value) prev.set("q", value);
        else prev.delete("q");
        return prev;
      },
      { replace: true },
    );
    resetPage();
  };
  const handleMenuClick = (e) => {
    console.log("click", e);
  };

  // useEffect(() => {
  //   fetchClients();
  // }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchClients();
    }, 300);

    return () => clearTimeout(handler);
  }, [fetchClients, listRefreshKey]);

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  const handleRow = (record) => {
    navigate(handleRouteNav("/client-profile", role_id), {
      state: { user_id: record.customer_id, routeType: "client" },
    });
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "customer_id",
      key: "customer_id",
      ellipsis: true,
      width: 100,
    },
    {
      title: "Company Name",
      dataIndex: "company_name",
      key: "company_name",
      ellipsis: true,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      ellipsis: true,
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      ellipsis: true,
    },
    {
      title: "Location",
      dataIndex: "state",
      key: "state",
      render: (_, record) => {
        // Check if customer_address exists and has default delivery
        const defaultDelivery = record.customer_address?.find(
          (addr) => addr.is_default_delivery === 1,
        );

        const city = defaultDelivery?.city || record.city || "";
        const state = defaultDelivery?.state || record.state || "";

        return `${city}${city && state ? ", " : ""}${state}`;
      },
      // render: (_, record) => {
      //   const city = record.city || "";
      //   const state = record.state || "";
      //   return `${city}${city && state ? ", " : ""}${state}`;
      // },
      ellipsis: true,
    },
  ];

  const { setTitle, setDescription, setBackButton } = useOutletContext();

  useEffect(() => {
    setTitle("Pending Clients");
    setDescription(
      is_admin ? (
        <div>
          <Breadcrumb>
            {[
              { title: "Home", href: handleRouteNav("/dashboard", role_id) },
              {
                title: "User Directory",
                href: handleRouteNav("/users", role_id),
              },
              {
                title: "Customer Directory",
                href: handleRouteNav("/customers", role_id),
              },
              {
                title: "Pending Clients",
                href: handleRouteNav(`/pending-clients`, role_id),
              },
            ].map((item, index) => (
              <Breadcrumb.Item key={index}>
                <Link to={item.href}>{item.title}</Link>
              </Breadcrumb.Item>
            ))}
          </Breadcrumb>
        </div>
      ) : (
        <div>
          <Breadcrumb>
            {[
              { title: "Home", href: handleRouteNav("/dashboard", role_id) },
              { title: "Clients", href: handleRouteNav("/clients", role_id) },
              {
                title: "Pending Clients",
                href: handleRouteNav(`/pending-clients`, role_id),
              },
            ].map((item, index) => (
              <Breadcrumb.Item key={index}>
                <Link to={item.href}>{item.title}</Link>
              </Breadcrumb.Item>
            ))}
          </Breadcrumb>
        </div>
      ),
    );
    setBackButton(true);
  }, [setTitle, setDescription, setBackButton]);

  return (
    <>
      <div
        className="bg-[#FFFFFF]"
        style={{ borderRadius: "32px", overflow: "hidden" }}
      >
        <div className="flex justify-between gap-7 items-center px-8 py-6">
          <SearchInput
            value={query}
            onSearch={onSearch}
            placeholder="Search for clients"
            onChange={handleOnSearchChange}
          />
          <div className="flex gap-3 items-center">
            {/* <Dropdown menu={menuProps}>
              <Button
                type="primary"
                className="bg-transparent hover:!bg-[#A33434] border border-[#A33434] text-[#000000] text-base"
                shape="round"
                size={"large"}
              >
                <Space>
                  Alphabetically (A-Z)
                  <FaCaretDown />
                </Space>
              </Button>
            </Dropdown> */}
            <PrimaryButton text="Client List" onClick={handleClient} noIcon />
            <Button
              type="primary"
              className="h-[45px] bg-[#7070701A]  hover:!bg-[#7070701A] hover:!text-[#A33434] font-bold text-[#A33434] text-base cursor-default"
            >
              {totalClients} clients
            </Button>
          </div>
        </div>
        {loading ? (
          <div className="flex justify-center items-center py-20">
            <Loader size={60} />{" "}
          </div>
        ) : (
          <DataTable
            columns={columns}
            data={data}
            handleChange={handleChange}
            handleRow={handleRow}
            pagination={{
              current: pagination.current,
              pageSize: pagination.pageSize,
              total: totalClients,
              showSizeChanger: true,
            }}
          />
        )}
      </div>
    </>
  );
};

export default PendingClients;
